import { Component, OnInit } from '@angular/core';
import {DataService} from '../../../../../../services/commande-client/data.service';

@Component({
  selector: 'app-cree-bon-sortie-negoce',
  templateUrl: './cree-bon-sortie-negoce.component.html',
  styleUrls: ['./cree-bon-sortie-negoce.component.scss']
})
export class CreeBonSortieNegoceComponent implements OnInit {

    constructor(private dataService: DataService) {}

    ngOnInit(): void {
        this.dataService.filterOrdersByStatus('Tous');
    }

}
